const variables = {
  AUTH: "fe_orionPortalAuth",
  COMPLET: "fe_orionPortalCompleto",
  EMAIL: "fe_orionEmailAuth",
  REMEMBER: "fe_orionPortalRemember",
  TOKEN: "fe_orionPortalToken",
  TOKENREFRESH: "fe_orionPortalRefreshToken",
  TOUR: "fe_orionPortalTour",
  USER: "fe_orionPortalUser",
  USER_TYPE: "fe_orionPortalUserType",
  AREASSEL: "fe_orionAreas",
  AREASSELCERVO: "fe_orionAreas_cervo",
  LASTCEIBA: "fe_orionLastCeiba",
  LASTCERVO: "fe_orionLastCervo",
  LASTXCELENCE: "fe_orionLastXcelencev3",
  LASTNOGAM3: "fe_orionLastNogam3",
  LASTNOGAM4: "fe_orionLastNogam4",
  LASTNOGAM5: "fe_orionLastNogam5",
  LASTNOGAM6: "fe_orionLastNogam6",
  LASTTEK: "fe_orionLastTek",
  PROVCENTER1: "fe_orionDatosCentroP1",
  PROVCENTER2: "fe_orionDatosCentroP2",
};

export default variables;
